module.exports = __webpack_public_path__ + "img/download.3db5c55b.svg";